export const minPasswordLength = 5;
export const maxPasswordLength = 18;
